// extracted by mini-css-extract-plugin
export default {"root":"UiuVH","small":"_2QBNO","normal":"_2KrFD"};